import { APIResponse, PaginatedAPIResponse } from "../models/NetworkResponse";
import { Service } from "../models/Services/Service";
import { ServiceFilter } from "../models/Services/ServiceFilter";
import { getAPI, postAPI } from "./Networking";

export default class ServiceAPI {
    getServices = async (
        filters: ServiceFilter
    ): Promise<PaginatedAPIResponse<Service>> => {
        try {
            const queryParams = new URLSearchParams();

            if (filters.page_no)
                queryParams.append("page_no", filters.page_no.toString());

            if (filters.limit) queryParams.append("limit", filters.limit.toString());

            if (filters.search_text)
                queryParams.append("search_text", filters.search_text.toString());

            if (filters.sort_by)
                queryParams.append("sort_by", filters.sort_by.toString());

            if (filters.sort_type)
                queryParams.append("sort_type", filters.sort_type.toString());

            const response = await getAPI(`/v5/services?${queryParams.toString()}`);

            return response.result;
        } catch (error) {
            throw error;
        }
    };

}
